import React from 'react';
import { observer, inject } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import {
  Grid,
  withStyles,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  Select,
  MenuItem,
  Menu,
  ListItemText,
  Typography,
  FormControl,
  TextField,
} from '@material-ui/core';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

class ModulesManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mapId: null,
      subGroupId: null,
      loading: false,
      dialogAddopen: false,
      anchorEl: null,
      routers: [],
      rowData: [],
      tenant: null,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.subGroup.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, tenantIds);
      this.props.subGroup.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.subGroup.resetData();
      await this.props.subGroup.setData('tenantIds', tenantIds);
      // await this.props.subGroup.getSubGroup();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('remove_module')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('remove')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.subGroup.deleteSubGroup(id);

          // delete subgroup from subgroupPermission as well
          await this.props.user.updateSubgroupPermission([id]);

          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('remove_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.subGroup.toJS();
                await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        }
      }
    });
  }

  handleMange = async (event, data) => {
    this.setState({
      anchorEl: event.currentTarget,
      rowData: data,
    });
  };

  handleCloseManage = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleAssignMapOpen = async (data) => {
    if (data) {
      let map = data[8];
      let subGroupId = data[0];
      this.setState((data) => {
        data.dialogAddopen = true;
        data.anchorEl = null;
        data.subGroupId = subGroupId;
        data.mapId = map.id;
        return data;
      });
      await this.props.maps.getMapByTenantId(data[7]);
    }
  };

  handleClose = () => {
    this.setState((data) => {
      data.dialogAddopen = false;
      data.subGroupId = null;
      data.mapId = null;
      return data;
    });
  };

  handleSubmit = async () => {
    const { mapId, subGroupId } = this.state;
    const { offset, limit, search, sort, order, tenantIds } = this.props.subGroup.toJS();
    await this.props.subGroup.assignMap(mapId, subGroupId);
    await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, tenantIds);
    this.setState((data) => {
      data.dialogAddopen = false;
      return data;
    });
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.subGroup.setData('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  createModule() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('modules/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_module')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.subGroup.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.subGroup.setData('offset', 0, false);
    this.props.subGroup.setData('search', value);
  };

  unassign(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('unassign_rooms_bed')}`,
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: `${t('unassign')}`,
      cancelButtonText: `${t('cancel')}`,
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.subGroup.unassign(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('unassign_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.subGroup.toJS();
                await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, tenantIds);
              } else {
                Swal.fire({
                  html: `<h4>${t('failed_to_unassign')}`,
                  type: 'error',
                });
              }
            });
          }
        } catch (e) {
          console.log('error', e);
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_unassign')}`,
              type: 'error',
            });
          }
        }
      }
    });
  }

  onMapChange = (e) => {
    const id = e.target.value;
    this.setState((prevState) => {
      prevState.mapId = id;
      return prevState;
    });
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.subGroup.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.subGroup.toJS();
    this.props.subGroup.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { rowData } = this.state;
    let { subGroups, loading, limit, search, sort, order } = this.props.subGroup.toJS();
    const page = subGroups.data ? subGroups.pagination.page - 1 : 0;
    const count = subGroups.data ? subGroups.pagination.count : 0;
    let { mapsInfo } = this.props.maps.toJS();

    (subGroups.data || []).map((val) => {
      val.map = val.map ? val.map : {};
      return val;
    });

    const ARRAYSIZE = 9;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) ? row[1] : ''}</div>;
          },
        },
      },
      {
        name: 'totalBed',
        label: `${t('no_of_bed')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) ? row[2] : ''}</div>;
          },
        },
      },
      {
        name: 'map.name',
        label: `${t('map')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'map.name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) ? row[3] : ''}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: 'type',
        label: `${t('type')}`,
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;

            // count bed for the subgroup
            let bedsCount = 0;
            const subGroupInfo = subGroups.data.filter(
              (sub) => sub.id === (this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''),
            );
            if (subGroupInfo.length > 0) {
              bedsCount = subGroupInfo[0].beds.length;
            }

            return (
              <div className={classes.actionBox}>
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={(e) => this.handleMange(e, row ? row : null)}
                  id={`selectManage-${row && row[0]}`}
                >
                  {t('manage')}
                  <Icons.ArrowRight />{' '}
                </Button>
                <Link to={`/app/modules/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`} title={t('view')}>
                  {' '}
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/modules/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  id={`UnassignModule-${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}`}
                  disabled={bedsCount === 0 ? true : false}
                  title={t('unassign')}
                  onClick={() => this.unassign(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.LinkOff color={bedsCount === 0 ? 'disabled' : 'primary'} />
                </IconButton>
                <IconButton
                  id={`DeleteModule-${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}`}
                  disabled={bedsCount === 0 ? false : true}
                  title={t('delete')}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color={bedsCount === 0 ? 'primary' : 'disabled'} />
                </IconButton>
              </div>
            );
          },
        },
      },
      {
        name: 'tenant.id',
        label: '',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'map',
        label: `${t('map')}`,
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_modules')} button={this.createModule()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} spacing={32} container>
          <Grid item xs={12}>
            <MUIDataTable
              data={subGroups.data || []}
              columns={columns}
              options={{
                count: subGroups.data ? subGroups.pagination.count : 0,
                page: subGroups.data ? subGroups.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  switch (action) {
                    case 'changePage':
                      this.props.subGroup.setData('offset', tableState.page * tableState.rowsPerPage);
                      break;
                    case 'changeRowsPerPage':
                      this.props.subGroup.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.subGroup.setData('offset', 0, false);
                      this.props.subGroup.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.subGroup.setData('offset', 0, false);
                      this.props.subGroup.setData('sort', sortList[4], false);
                      this.props.subGroup.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>

        <Dialog
          onClose={this.handleClose}
          open={this.state.dialogAddopen}
          aria-labelledby='form-dialog-title'
          maxWidth='sm'
          fullWidth
        >
          <DialogTitle className='header' id='form-dialog-title'>
            {t('select_map')}
          </DialogTitle>
          <DialogContent>
            <Grid>
              <Grid item xs={12} className='deviceSelect'>
                <Paper className={`${classes.root} selectInput`}>
                  <Select
                    value={this.state.mapId || ' '}
                    onChange={(e) => {
                      this.onMapChange(e);
                    }}
                    inputProps={{
                      name: 'assing-router',
                      id: 'assing-router',
                    }}
                  >
                    <MenuItem fullwidth='true' key={9999999} value={' '}>
                      {t('please_select_map')}
                    </MenuItem>
                    {(mapsInfo || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'map name'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container item justify='flex-end'>
              <Button className={classes.button} onClick={this.handleClose} color='default'>
                {t('cancel')}
              </Button>
              <Button onClick={this.handleSubmit} color='primary' className={classes.button}>
                {t('save')}
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>

        <Menu
          id='selectManage'
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleCloseManage}
          className={classes.gridMenu}
        >
          {this.validateTableRow(rowData, ARRAYSIZE) && rowData[5] !== 'home' && (
            <MenuItem>
              <Link to={`/app/modules/${this.validateTableRow(rowData, ARRAYSIZE) ? rowData[0] : ''}/manage`}>
                <Typography>{t('bed')}</Typography>
              </Link>
            </MenuItem>
          )}
          <MenuItem>
            <Link to={`/app/modules/${this.validateTableRow(rowData, ARRAYSIZE) ? rowData[0] : ''}/manage/device`}>
              <Typography>{t('device')}</Typography>
            </Link>
          </MenuItem>
          <MenuItem onClick={() => this.handleAssignMapOpen(rowData ? rowData : null)}>
            <ListItemText
              primary={
                <React.Fragment>
                  <Typography>{t('map')}</Typography>
                </React.Fragment>
              }
            />
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  actionBox: {
    minWidth: '480px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  gridMenu: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 14,
    marginBottom: theme.spacing.unit * 10,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('subGroup', 'maps', 'user')(observer(ModulesManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
